<template>
	<div class="container-fluid">
		<div class="card">
			<div class="card-header bg-info text-white">
				Opciones de filtrado
			</div>
			<div class="card-body">
				<div class="row">
					<div class="mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="permisos.facturacion_consultar_todos">
						<h6>Agente</h6>
						<div class="input-group input-group-sm">
							<input-query url="consultas-facturacion/php/api/porAgente/query-agentes.php" @selected="otroAgente($event)" :realtime="true" input-class="form-control form-control-sm m-0 p-0"></input-query>
							<div class="input-group-append">
								<button class="btn btn-sm btn-warning" @click="getActivos()">
									<span class="fa fa-users"></span>
								</button>
							</div>
						</div>
						<div style="position:relative;display:block;" v-if="filtro.agentes.length > 0" class="bg-light p-1 m-1">
							<button class="m-1 btn btn-sm btn-warning" v-for="agente in filtro.agentes" :key="agente.ID" @click="quitaAgente(agente.ID)">
								{{agente.nombre}}
							</button>
						</div>
						<div class="mt-1">
							<button class="m-1 btn btn-sm" :class="(filtro.verTodosAgentes) ? 'btn-primary' : ''" @click="filtro.verTodosAgentes = !filtro.verTodosAgentes">Todos sumados</button>
							<button class="m-1 btn btn-sm" :class="(filtro.verSinAgente) ? 'btn-primary' : ''" @click="filtro.verSinAgente = !filtro.verSinAgente">Sin agente</button>
						</div>
					</div>

					<!-- SI NO PUEDE CONSULTAR LO DE TODOS -->
					<div class="mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="!permisos.facturacion_consultar_todos">
						<H6>Agente</H6>
						<img :src="usuario.avatar" alt="" class="rounded-circle" style="width:50px;height:50px;vertical-align:middle;margin-right:10px;">
						<b>{{usuario.nombre}} {{usuario.apellidos}}</b>
					</div>
					<div class="mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
						<h6>Intérvalo de fechas</h6>
						<div class="row">
							<div class="col">
								<datepicker
								v-model="filtro.fecha_ini"
								format="MMMM, yyyy"
								placeholder="Inicio"
								:monday-first="true"
								:language='$dateLang'
								input-class="form-control form-control-sm"
								minimum-view="month"
								></datepicker>
							</div>
							<div class="col">
								<datepicker
								v-model="filtro.fecha_fin"
								format="MMMM, yyyy"
								placeholder="Fin"
								:monday-first="true"
								:language='$dateLang'
								input-class="form-control form-control-sm"
								minimum-view="month"
								></datepicker>
							</div>
						</div>
						<div class="form-group mt-2">
							<label for="">Título del contrato</label>
							<input type="text" class="form-control form-control-sm" v-model="filtro.titulo" @keypress.enter="consultar">
						</div>
					</div>
					<div class="mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
						<h6>Soportes</h6>
						<button class="m-1 btn btn-sm" :class="(filtro.soportes.indexOf(soporte.ID_soporte) >= 0) ? 'btn-primary' : 'btn-default'" v-for="soporte in listadoSoportes" :key="soporte.ID_soporte" @click="toggleSoporte(soporte.ID_soporte)">
							{{soporte.soporte}}
						</button>
					</div>
					<div class="mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
						<h6>Campos</h6>
						<button class="m-1 btn btn-sm" :class="(filtro.campos.indexOf(campo.ID) >= 0) ? 'btn-primary' : 'btn-default'" v-for="campo in listadoCampos" :key="campo.ID" @click="toggleCampo(campo.ID)">
							{{campo.nombre}}
						</button>
					</div>
				</div>
			</div>
			<div class="card-body" style="border-top:10px solid #e0e0e0;">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<h6>Partidas</h6>
						<table class="table table-condensed" style="border:1px solid #e0e0e0;">
							<tbody>
								<tr v-for="(partida, index) in filtro.partidas" :key="partida.ID_destino">
									<td class="p-0 pl-2" style="vertical-align:middle;">{{partida.titulo}}</td>
									<td class="p-0 text-right">
										<div class="btn-group">
											<button class="btn btn-sm" :class="(filtro.partidas[index].d) ? 'btn-primary' : ''" @click="filtro.partidas[index].d = !filtro.partidas[index].d">
												D
											</button>
											<button class="btn btn-sm" :class="(filtro.partidas[index].c) ? 'btn-primary' : ''" @click="filtro.partidas[index].c = !filtro.partidas[index].c">
												C
											</button>
											<button class="btn btn-sm" :class="(filtro.partidas[index].r) ? 'btn-primary' : ''" @click="filtro.partidas[index].r = !filtro.partidas[index].r">
												R
											</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<h6>Facturado a:</h6>
						<div>
							<button class="m-1 btn btn-sm" :class="(filtro.destinos.indexOf(destino.DestinoID) >= 0) ? 'btn-primary' : ''" v-for="destino in listadoDestinos" :key="destino.DestinoID" @click="toggleDestino(destino.DestinoID)">
								{{destino.Nombre}}
							</button>
						</div>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<h6>Eventos</h6>
						<table class="table table-condensed" style="border:1px solid #e0e0e0;">
							<tbody>
								<tr v-for="(evento, index) in filtro.eventos" :key="evento.ID">
									<td class="p-0 pl-2" style="vertical-align:middle;">{{evento.nombre}}</td>
									<td class="p-0 text-right">
										<div class="btn-group">
											<button class="btn btn-sm" :class="(filtro.eventos[index].d) ? 'btn-primary' : ''" @click="filtro.eventos[index].d = !filtro.eventos[index].d">
												D
											</button>
											<button class="btn btn-sm" :class="(filtro.eventos[index].c) ? 'btn-primary' : ''" @click="filtro.eventos[index].c = !filtro.eventos[index].c" :disabled="filtro.eventos[index].c === null">
												C
											</button>
											<button class="btn btn-sm" :class="(filtro.eventos[index].r) ? 'btn-primary' : ''" @click="filtro.eventos[index].r = !filtro.eventos[index].r">
												R
											</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<button class="btn btn-sm btn-primary" @click="consultar()">
					<span class="fa fa-search mr-1"></span>
					Consultar
				</button>
			</div>
		</div>
		<div v-if="resultados !== null" class="m-2">
			<div class="card mb-3" v-for="agente in resultados.agentes" :key="agente.info.agenteId">
				<div class="card-header bg-info text-white" style="font-size:1.2em;font-weight:bold;">
					<div class="row">
						<div class="col text-left">
							<span class="fa fa-user mr-1"></span>
							{{agente.info.nombre}}
						</div>
					</div>
				</div>
				<div class="table-responsive">
					<table class="m-0 table table-condensed table-striped">
						<thead class="bg-light">
							<tr>
								<td class="bg-dark"></td>
								<template v-if="resultados.soportes">
									<td class="text-right" v-for="soporte in resultados.soportes" :key="'sop_' + soporte.id">
										{{soporte.nombre}}
									</td>
								</template>
								<template v-if="resultados.eventos && resultados.eventos.c">
									<td class="text-right" v-for="evento in resultados.eventos.c" :key="'ev_'+evento.id">
										{{evento.titulo}}
									</td>
								</template>
								<template v-if="resultados.partidas && resultados.partidas.c" >
									<td class="text-right" v-for="partida in resultados.partidas.c" :key="'par_'+partida.id">
										{{partida.titulo}}
									</td>
								</template>
								<template v-if="resultados.totales">
									<td class="text-right bg-danger text-white" v-for="total in resultados.totales" :key="'tot_' + total.nombre">
										{{total.nombre}}
									</td>
								</template>
							</tr>
						</thead>
						<tbody>
							<tr v-for="campo in resultados.campos" :key="campo.id">
								<td class="text-right bg-dark text-white">
									{{campo.nombre}}
								</td>
								<template v-if="resultados.soportes">
									<td
										:class="(campo.id.match(/^(cobertura|cobertura_acum)$/)) ? 'bg-warning' : ''"
										class="text-right"
										style="cursor:pointer"
										v-for="soporte in resultados.soportes"
										:key="agente.info.agenteId+'_'+campo.id+'_sop_'+soporte.id"
										@click="verDetalles(agente, campo, agente.campos[campo.id].datos.soportes[soporte.id].facturacion, soporte.nombre)">
											<span v-if="campo.id.match(/^(cobertura|cobertura_acum)$/)">
												{{agente.campos[campo.id].datos.soportes[soporte.id].importe | currency('%')}}
											</span>
											<span v-else>
												{{ agente.campos[campo.id].datos.soportes[soporte.id].importe | currency }}
											</span>
									</td>
								</template>

								<template v-if="resultados.eventos">
									<td
										:class="(campo.id.match(/^(cobertura|cobertura_acum)$/)) ? 'bg-warning' : 'bg-info text-white'"
										class="text-right"
										v-for="evento in resultados.eventos.c"
										:key="agente.info.agenteId+'_'+campo.id+'_ev_'+evento.id"
										style="cursor:pointer"
										@click="verDetalles(agente, campo, agente.campos[campo.id].datos.eventos[evento.id].facturacion, 'Eventos')">
											<span v-if="campo.id.match(/^(cobertura|cobertura_acum)$/)">
												{{agente.campos[campo.id].datos.eventos[evento.id].importe | currency('%')}}
											</span>
											<span v-else>
												{{agente.campos[campo.id].datos.eventos[evento.id].importe | currency }}
											</span>
									</td>
								</template>

								<template v-if="resultados.partidas && resultados.partidas.c">
									<td
										:class="(campo.id.match(/^(cobertura|cobertura_acum)$/)) ? 'bg-warning' : 'bg-info text-white'"
										class="text-right"
										v-for="partida in resultados.partidas.c"
										:key="agente.info.agenteId+'_'+campo.id+'_par_'+partida.id"
										style="cursor:pointer"
										@click="verDetalles(agente, campo, agente.campos[campo.id].datos.partidas[partida.id].facturacion, partida.titulo)">
											<span v-if="campo.id.match(/^(cobertura|cobertura_acum)$/)">
												{{agente.campos[campo.id].datos.partidas[partida.id].importe | currency('%')}}
											</span>
											<span v-else>
												{{agente.campos[campo.id].datos.partidas[partida.id].importe | currency }}
											</span>
									</td>
								</template>

								<template v-if="resultados.totales">
									<td
										class="text-right bg-danger text-white"
										v-for="total in resultados.totales"
										@click="verGraficos(agente, campo)"
										:style="(campo.id === 'real') ? {cursor: 'pointer'} : {}"
										:key="agente.info.agenteId+'_'+campo.id+'_tot_'+total.nombre">
											<span v-if="campo.id.match(/^(cobertura|cobertura_acum)$/)">
												{{agente.totales[total.nombre].datos.campos[campo.id].importe | currency('%')}}
											</span>
											<span v-else>
												{{agente.totales[total.nombre].datos.campos[campo.id].importe | currency }}
											</span>
									</td>
								</template>
							</tr>
						</tbody>
						<!-- Desglose de eventos -->

						<!-- / Fin desglose de eventos -->

						<!-- Desglose de partidas -->

						<!-- Fin de desglose de partidas -->
					</table>
				</div>
			</div>
		</div>
		<graficos-totales @cerrar="grafico = null" v-if="grafico" :datos="grafico"></graficos-totales>
		<graficos-detalles @cerrar="detalles = null" v-if="detalles" :datos="detalles"></graficos-detalles>
	</div>
</template>

<script>
import API from './api.js'
import GraficosTotales from './graficosTotales'
import GraficosDetalle from './graficoDetalle'
import { mapGetters } from 'vuex'

export default {
	components: {
		'graficos-totales': GraficosTotales,
		'graficos-detalles': GraficosDetalle
	},
	data () {
		return {
			filtro: {
				agentes: [],
				verTodosAgentes: false,
				verSinAgente: false,
				fecha_ini: new Date(new Date().getFullYear(), 0, 1),
				fecha_fin: new Date(new Date().getFullYear(), 11, 1),
				titulo: '',
				partidas: [],
				soportes: [],
				campos: [],
				destinos: [],
				eventos: [
					{
						id: 'real',
						nombre: 'Eventos',
						d: false,
						c: true,
						r: true
					},
					{
						id: 'acum',
						nombre: 'Eventos acumulados',
						d: false,
						c: null,
						r: true
					}
				]
			},
			listadoSoportes: [],
			listadoPartidas: [],
			listadoDestinos: [],
			listadoCampos: [],
			resultados: null,
			grafico: null,
			detalles: null
		}
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		})
	},

	created () {
		// Obtenemos todos los campos del formulario
		API.getCamposFormulario()
			.then(res => {
				this.listadoSoportes = res.data.soportes
				this.listadoDestinos = res.data.destinos
				this.listadoCampos = res.data.campos

				for (let i = 0; i < this.listadoSoportes.length; i++) {
					this.toggleSoporte(this.listadoSoportes[i].ID_soporte)
				}

				for (let i = 0; i < this.listadoCampos.length; i++) {
					this.toggleCampo(this.listadoCampos[i].ID)
				}

				for (let i = 0; i < res.data.partidas.length; i++) {
					this.filtro.partidas.push({
						id: res.data.partidas[i].ID_partida,
						titulo: res.data.partidas[i].titulo,
						d: false,
						c: true,
						r: true
					})
				}
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},

	methods: {
		getActivos () {
			API.getAgentesActivos()
				.then(res => {
					this.filtro.agentes = res.data.usuarios
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		otroAgente (datos) {
			for (let i = 0; i < this.filtro.agentes.length; i++) {
				if (this.filtro.agentes[i].ID === datos.datos.ID) {
					return
				}
			}
			const age = {
				nombre: datos.datos.nombre + ' ' + datos.datos.apellidos,
				ID: datos.datos.ID
			}
			this.filtro.agentes.push(age)
		},
		quitaAgente (ID) {
			for (let i = 0; i < this.filtro.agentes.length; i++) {
				if (this.filtro.agentes[i].ID === ID) {
					this.filtro.agentes.splice(i, 1)
				}
			}
		},
		toggleSoporte (ID) {
			const idx = this.filtro.soportes.indexOf(ID)

			if (idx >= 0) {
				this.filtro.soportes.splice(idx, 1)
				return
			}

			this.filtro.soportes.push(ID)
		},

		toggleCampo (ID) {
			const idx = this.filtro.campos.indexOf(ID)

			if (idx >= 0) {
				this.filtro.campos.splice(idx, 1)
				return
			}

			this.filtro.campos.push(ID)
		},

		toggleDestino (ID) {
			const idx = this.filtro.destinos.indexOf(ID)

			if (idx >= 0) {
				this.filtro.destinos.splice(idx, 1)
				return
			}

			this.filtro.destinos.push(ID)
		},

		consultar () {
			API.consultarPorAgentes(this.filtro)
				.then(res => {
					this.resultados = res.data
					this.resultados.fechas = {
						fecha_ini: this.filtro.fecha_ini,
						fecha_fin: this.filtro.fecha_fin
					}
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		verGraficos (data, campo) {
			if (campo.id === 'real') {
				data.fechas = this.resultados.fechas
				this.grafico = data
			}
		},

		verDetalles (agente, campo, facturacion, dimension) {
			this.detalles = {
				agente: agente,
				campo: campo,
				facturacion: facturacion,
				dimension: dimension,
				fechas: this.resultados.fechas
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porAgente/main.vue